var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoinsSpent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Coins_spent"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coins_spent",
    clipPath: "url(#clip-Coins_spent)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2110",
    "data-name": "Group 2110",
    transform: "translate(0 -0.009)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M9,19.791,23.875,6.757A3.056,3.056,0,0,1,28.92,9.179V19.791Z",
    transform: "translate(-1.637 -0.933)",
    fill: "#44bc59"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M17,21.428l16.133-8.045a3.065,3.065,0,0,1,4.553,2.634v5.411Z",
    transform: "translate(-3.508 -2.57)",
    fill: "#2d9739"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M44.138,43.154v5.363a4.6,4.6,0,0,1-4.6,4.6H6.6a4.6,4.6,0,0,1-4.6-4.6V28.6A4.6,4.6,0,0,1,6.6,24H39.541a4.6,4.6,0,0,1,4.6,4.6V43.154Z",
    transform: "translate(0 -5.143)",
    fill: "#624434"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M39.951,53.114h2.63a4.6,4.6,0,0,0,4.6-4.6V28.6a4.6,4.6,0,0,0-4.6-4.6H15C15,38.194,25.661,50.067,39.951,53.114Z",
    transform: "translate(-3.04 -5.143)",
    fill: "#755640"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M54.258,46.194H45.065c-2.539,0-3.065-2.058-3.065-4.6s.526-4.6,3.065-4.6h9.194a3.065,3.065,0,0,1,3.065,3.065v3.065A3.065,3.065,0,0,1,54.258,46.194Z",
    transform: "translate(-9.354 -8.183)",
    fill: "#624434"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_760",
    "data-name": "Ellipse 760",
    cx: 2.188,
    cy: 2.461,
    rx: 2.188,
    ry: 2.461,
    transform: "translate(35.912 31.019)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M52.05,8.131a5.527,5.527,0,0,1-2.572,5.842L49,14.26l3.065,2.3.135-.09a10.023,10.023,0,0,0,4.462-8.338h1.748a.539.539,0,0,0,.382-.921L55.266,2.469a1.142,1.142,0,0,0-1.834,0l-3.5,4.717a.552.552,0,0,0,.391.944h1.73l.015.035Z",
    transform: "translate(-10.991 0)",
    fill: "#ffc239"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M56.2,3.019l-3.271,4.4a.552.552,0,0,0,.391.944h1.73a5.525,5.525,0,0,1-2.572,5.842L52,14.5l1.913,1.435a10.021,10.021,0,0,0,3.45-7.564h1.748a.539.539,0,0,0,.382-.921Z",
    transform: "translate(-11.693 -0.236)",
    fill: "#ffd55d"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoinsSpent);
export default __webpack_public_path__ + "static/media/Coins_spent.1982133d.svg";
export { ForwardRef as ReactComponent };